var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('white-frame',{scopedSlots:_vm._u([{key:"main",fn:function(){return [_c('p',{},[_vm._v(_vm._s(_vm.teacherSuffix)+"データがありません。追加ボタンで登録してください。")])]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }